export namespace StringUtil {
    export function isNullOrEmpty(str: string | undefined | null): boolean {
        return str === undefined || str === null || str.trim().length === 0;
    }

    export function objectToQueryString(obj: { [key: string]: string }) {
        const params = new URLSearchParams();
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                params.append(key, obj[key]);
            }
        }
        return params.toString();
    }
}